import React, { useState } from "react";
import { Plus } from "lucide-react";
import { LINE_2, BURGUNDY, BURGUNDY_TINT, INK_2, INK_3 } from "../bureauTokens";

function SuggestTile({ onClick }) {
  const [hover, setHover] = useState(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="flex flex-col items-center justify-center gap-1.5 text-center p-3.5 min-h-[92px] transition-all"
      style={{
        background: hover ? BURGUNDY_TINT : "transparent",
        border: `1.5px dashed ${hover ? BURGUNDY : LINE_2}`,
        borderRadius: 14,
        transform: hover ? "translateY(-1px)" : "none",
      }}
    >
      <span
        className="w-8 h-8 rounded-[10px] flex items-center justify-center transition-all duration-700 ease-in-out"
        style={{
          background: hover ? "#fff" : BURGUNDY_TINT,
          color: BURGUNDY,
          // 3 tours complets (multiple de 360°) : le "+" revient bien aligné
          // comme au repos une fois l'animation terminée.
          transform: hover ? "rotate(1080deg)" : "rotate(0deg)",
        }}
      >
        <Plus size={16} />
      </span>
      <div className="text-[11px] font-semibold" style={{ color: INK_2 }}>
        Suggérer une idée
      </div>
      <div className="text-[10px]" style={{ color: INK_3 }}>
        Personnaliser cette tuile
      </div>
    </button>
  );
}

export default SuggestTile;
